import { getSelectedCompanySelector } from 'common/store/selectors/companies.selectors';
import { SelectedCompany } from 'common/types';
import { useSelector } from 'react-redux';

// TODO: move this away, once `company.transformers.js` is rewritten in TS

export const useSelectCompanySelected = () => {
  return useSelector<unknown, SelectedCompany>(getSelectedCompanySelector);
};
